"use strict";
/**
 * Copyright © 2020 Johnson & Johnson
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.asBreadcrumbSource = exports.withMenuDesign = exports.asMenuBase = exports.asMenuSubList = void 0;

var lodash_1 = require("lodash");

var fclasses_1 = require("@bodiless/fclasses");

var components_1 = require("@bodiless/components");

var SimpleMenu_1 = require("./SimpleMenu");

Object.defineProperty(exports, "asMenuSubList", {
  enumerable: true,
  get: function get() {
    return SimpleMenu_1.asMenuSubList;
  }
});

var SimpleMenu_token_1 = require("./SimpleMenu.token");

var withMenuContext_1 = __importDefault(require("./withMenuContext"));
/**
 * Applies a list design (or other HOC) recursively to all submenus.
 *
 * @param design The design object or HOC to be applied.
*/


var withSubMenuDesign = function withSubMenuDesign(design) {
  var withDesign$ = typeof design === 'function' ? design : fclasses_1.withDesign(design);
  return fclasses_1.withDesign({
    Item: fclasses_1.withDesign({
      List: withDesign$,
      Touts: withDesign$,
      Columns: lodash_1.flow(withDesign$, fclasses_1.withDesign({
        Item: withDesign$
      }))
    })
  });
};
/**
 * Applies a list design (or other HOC) to the main menu and all submenus.
 *
 * @param design The design object or HOC to be applied.
*/


var withMenuDesign = function withMenuDesign(design) {
  var withDesign$ = typeof design === 'function' ? design : fclasses_1.withDesign(design);
  return lodash_1.flow(withSubMenuDesign(withDesign$), withDesign$);
};

exports.withMenuDesign = withMenuDesign;
/**
 * Bodiless HOC generator which creates the basic structure of the Mega Menu. The component
 * to which the HOC applies is irrelevant (it will be replaced by the Menu wrapper).
 *
 * The base mega menu serves as a base for various views on the Menu data, including
 * a site's main menu, a burger menu and breadcrumbs.
 *
 * @param nodeKeys The optional nodekeys specifying where the data should be stored.

 * @return HOC which creates a basic mega menu list.
 */

var asMenuBase = function asMenuBase(nodeKeys) {
  return lodash_1.flow(components_1.asBodilessList(nodeKeys, undefined, function () {
    return {
      groupLabel: 'Menu Item'
    };
  }), SimpleMenu_token_1.asStylableList, fclasses_1.withDesign({
    Item: components_1.asChameleonSubList(function () {
      return {
        formTitle: 'Sub-Menu Type'
      };
    })
  }), withSubMenuDesign(SimpleMenu_1.asMenuSubList), withMenuContext_1.default);
};

exports.asMenuBase = asMenuBase;
var asBreadcrumbSource = components_1.asBreadcrumbSource(withMenuDesign);
exports.asBreadcrumbSource = asBreadcrumbSource;